export const checksums = {
  "content": "v3.5.0--Un6o5o7ifos5Rk0xVNLXuwzp_4xDnICOaPGI1H21fdE"
}
export const checksumsStructure = {
  "content": "C741W91MJt55mV0XseublXZL3PfwJwnj1zK3kbr0nWs"
}

export const tables = {
  "content": "_content_content",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authorImage": "string",
      "authorName": "string",
      "body": "json",
      "category": "string",
      "cover": "string",
      "coverAlt": "string",
      "date": "string",
      "dateLabel": "string",
      "description": "string",
      "draft": "boolean",
      "excerpt": "string",
      "extension": "string",
      "keywords": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "readTime": "string",
      "relatedPosts": "json",
      "seo": "json",
      "seoTitle": "string",
      "sitemap": "json",
      "stem": "string",
      "updated": "string",
      "updatedLabel": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}